export const SUBSCRIPTIONS_TAB_TIMEOUT = 7200000; // 2hrs
